import type { FaireProductEntity } from "../../entity_types/product";

export const p_a6af98vw2a: FaireProductEntity = {
  token: "p_a6af98vw2a",
  type: "product",
  name: 'Golden Hour 7.5-8.5" Jade, Rhyolite, Jasper Simple Bracelet',
  brandToken: "b_45afe46d",
  brandName: "Anne Vaughan Designs Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/5994ec6b3b31af52f152d0a6ebd33e9b2ab468de6a846058025e960c12deff4a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5daa3d7b487751aa30835e5b840d7774d4f67d1867327bad0c9ee4b8d4937c6c.jpeg",
    "https://cdn.faire.com/fastly/f046d461dd450448320516a27f63eb3e3e13e0abc18cf365e3b381e6b2f4058b.jpeg",
  ],
  priceDollars: 22,
  description:
    'There is a fleeting moment just before the sun dips below the horizon when the world is bathed in a warm, liquid-gold light. The Golden Hour Collection is an invitation to carry that radiant, tranquil glow with you always. Inspired by late-summer afternoons drifting into the quiet promise of autumn, this collection is an homage to sun-warmed earth, botanical beauty, and celestial mystery.\n\n * Matte Gold Plated Brass (Lead & Nickel Free) \n * Jade, Rhyolite, Jasper \n * 7.5-8.5" adjustable with matte gold plated brass lobster claw clasp \n * We hand select our natural materials, thus there may be slight variations in color and/or size that will not detract from the overall aesthetic. \n * Our unique handcrafted designer jewelry for women is made in America, each design created individually in our personal design studio in Floyd, VA USA ',
  tags: [],
  msrpDollars: 44,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:53.846Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
